import CRUDService from './CRUDService';
import PlatformService, {AppPlatform} from './PlatformService';
import {EducationPhase} from '../types/enums';

export interface ToolbarNotificationShape {
  _id: string;
  _type: string;
  identifier: string;
  htmlContent: string;
  priority: number;
  active: boolean;
  includedUserGroups?: string[];
  includedHighSchoolStates?: string[];
  includedGradYears?: string[];
  includedAges?: string[];
  includedStates?: string[];
  includedPlatforms?: AppPlatform[];
  includedEducationPhases?: EducationPhase[];
  owners: string[];
  updatedAt: string;
  lastUpdatedBy: string;
  createdAt: string;
}

class ToolbarNotificationService extends CRUDService<ToolbarNotificationShape> {
  async showCurrent(): Promise<ToolbarNotificationShape | null> {
    const platform = await new PlatformService().getPlatform();
    return this.show('current', {devicePlatform: platform});
  }

  dismiss(toolbarNotificationId: string): Promise<ToolbarNotificationShape> {
    return this.update(`${toolbarNotificationId}/dismiss`, {});
  }
}
export default new ToolbarNotificationService({baseUrl: '/v1/toolbar-notifications', useJWT: true});
